import { Menu } from "@mantine/core";
import React    from "react";

import Icon       from "_components/atoms/icon";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/molecules/socialMediaButtons";

const component = ( { youtubeHandle, instagramHandle, discordHandle, anchorEl, handleClick, handleClose } ) => {
	const { classes } = useStyles ( );

	return (
		<div>

			<Menu
				keepMounted
				autoFocus = { false }
				className = { classes.menuContainer }
				onClose            = { handleClose }
				opened               = { Boolean ( anchorEl ) }
				p = "md"
				position = "right-start"
				radius = { "lg" }
				styles = { { dropdown: { padding: "0rem 0rem !important" }, item: { borderRadius: "0", padding: "1rem 1rem" } } }
			>
				<Menu.Target>
					<div className = { classes.container }
						onClick = { handleClick }
					>
						{instagramHandle && (
							<Icon sameInBothTheme
								className = { `${ classes.igIcon } ${ classes.socialMediaIcon }` }
								name = "instagram"
							/>
						)}

						{youtubeHandle && (
							<Icon sameInBothTheme
								className = { `${ classes.ytIcon } ${ classes.socialMediaIcon }` }
								name = "youtube"
							/>
						)}

						{discordHandle && (
							<Icon sameInBothTheme
								className = { `${ classes.socialMediaIcon }` }
								name = "discord"
							/>
						)}
					</div>
				</Menu.Target>

				<Menu.Dropdown>

					{instagramHandle && (
						<Menu.Item
							className = { classes.menuItem }
						>
							<a
								className = { classes.anchorText }
								href      = { instagramHandle.includes ( "https://" ) ? instagramHandle : `https://www.instagram.com/${ instagramHandle }` }
								rel       = "noreferrer"
								target    = "_blank"
							>
								<Icon sameInBothTheme
									className = { classes.socialMediaIcon }
									name = "instagram"
								/>

								<Typography
									className = "fontBold  leftSpacing fontGrey"
									color     = "primary"
									title = { "Instagram" }
									variant   = "body2"
								/>
							</a>
						</Menu.Item>
					)}

					{youtubeHandle && (
						<Menu.Item
							className = { classes.menuItem }
						>
							<a className = { classes.anchorText }
								href      = { youtubeHandle }
								rel       = "noreferrer"
								target    = "_blank"
							>
								<Icon sameInBothTheme
									className = { `${ classes.socialMediaIcon }` }
									name = "youtube"
								/>

								<Typography
									className = "fontBold  leftSpacing fontGrey"
									color     = "primary"
									title = { "YouTube" }
									variant   = "body2"
								/>
							</a>
						</Menu.Item>
					)}

					{discordHandle && (
						<Menu.Item
							className = { classes.menuItem }
						>
							<a className = { classes.anchorText }
								href      = { discordHandle }
								rel       = "noreferrer"
								target    = "_blank"
							>
								<Icon sameInBothTheme
									className = { `${ classes.socialMediaIcon }` }
									name = "discord"
								/>

								<Typography
									className = "fontBold  leftSpacing fontGrey"
									color     = "primary"
									title = { "Discord" }
									variant   = "body2"
								/>
							</a>
						</Menu.Item>
					)}
				</Menu.Dropdown>
			</Menu>

		</div>

	);
};

export default component;
